<template>
  <v-layout row justify-center>
    <v-btn color="primary" dark @click.stop="cardDialog = true">
      {{ $t('addNewCard') }}
    </v-btn>

    <v-dialog v-model="cardDialog" persistent max-width="400">
      <v-card>
        <v-card-text>
          <v-container fluid grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm12 md12>
                <v-text-field v-model="card.card_number"
                              name="card_number"
                              :label="$t('card_number')"
                              v-validate="'required'"
                              :error-messages="errors.collect('card_number')"
                              data-vv-name="card_number"
                              :data-vv-as="$t('card_number')"
                              required
                              mask="#### #### #### ####"
                              ></v-text-field>
              </v-flex>

              <v-flex xs12 sm12 md12>
                <v-text-field v-model="card.holder_name"
                              name="holder_name"
                              :label="$t('holder_name')"
                              v-validate="'required'"
                              :error-messages="errors.collect('holder_name')"
                              data-vv-name="holder_name"
                              :data-vv-as="$t('holder_name')" required
                              ></v-text-field>
              </v-flex>

              <v-flex xs12 sm12 md4>
                <v-text-field v-model="card.expiration_month"
                              name="expiration_month"
                              :label="$t('expiration_month')"
                              v-validate="'required'"
                              :error-messages="errors.collect('expiration_month')"
                              data-vv-name="expiration_month"
                              :data-vv-as="$t('expiration_month')"
                              required
                              mask="##"
                              ></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md4>
                <v-text-field v-model="card.expiration_year"
                              name="expiration_year"
                              :label="$t('expiration_year')"
                              v-validate="'required'"
                              :error-messages="errors.collect('expiration_year')"
                              data-vv-name="expiration_year"
                              :data-vv-as="$t('expiration_year')"
                              required
                              mask="##"
                              ></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md4>
                <v-text-field v-model="card.cvv2"
                              name="cvv2"
                              :label="$t('cvv2')"
                              v-validate="'required'"
                              :error-messages="errors.collect('cvv2')"
                              data-vv-name="cvv2"
                              :data-vv-as="$t('cvv2')"
                              required
                              mask="####"
                              ></v-text-field>
              </v-flex>

              <!-- Address -->

              <v-flex xs12 sm12 md12>
                {{ $tc('models.address') }}
              </v-flex>

              <v-flex xs12 sm12 md6>
                <v-text-field v-model="address.line1"
                              name="line1"
                              :label="$t('attrs.street')"
                              v-validate="'required'"
                              :error-messages="errors.collect('line1')"
                              data-vv-name="line1"
                              :data-vv-as="$t('attrs.street')"
                              required
                              ></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md6>
                <v-text-field v-model="address.line2"
                              name="line2"
                              :label="$t('attrs.number')"
                              v-validate="'required'"
                              :error-messages="errors.collect('line2')"
                              data-vv-name="line2"
                              :data-vv-as="$t('attrs.number')"
                              required
                              ></v-text-field>
              </v-flex>

              <v-flex xs12 sm12 md6>
                <v-text-field v-model="address.line3"
                              name="line3"
                              :label="$t('attrs.neighborhood')"
                              v-validate="'required'"
                              :error-messages="errors.collect('line3')"
                              data-vv-name="line3"
                              :data-vv-as="$t('attrs.neighborhood')"
                              required
                              ></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md6>
                <v-text-field v-model="address.city"
                              name="city"
                              :label="$t('attrs.city')"
                              v-validate="'required'"
                              :error-messages="errors.collect('city')"
                              data-vv-name="city"
                              :data-vv-as="$t('attrs.city')"
                              required
                              ></v-text-field>
              </v-flex>

              <v-flex xs12 sm12 md6>
                <v-text-field v-model="address.state"
                              name="state"
                              :label="$t('attrs.state')"
                              v-validate="'required'"
                              :error-messages="errors.collect('state')"
                              data-vv-name="state"
                              :data-vv-as="$t('attrs.state')"
                              required
                              ></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md6>
                <v-text-field v-model="address.postal_code"
                              name="postal_code"
                              :label="$t('attrs.postal_code')"
                              v-validate="'required'"
                              :error-messages="errors.collect('postal_code')"
                              data-vv-name="postal_code"
                              :data-vv-as="$t('attrs.postal_code')"
                              required
                              ></v-text-field>
              </v-flex>

              <v-flex xs12 sm12 md12>
                <v-select v-model="address.country_code"
                          :items="countries"
                          item-value="alpha-2"
                          item-text="name"
                          v-validate="'required'"
                          :error-messages="errors.collect('country_code')"
                          data-vv-name="country_code"
                          :label="$tc('models.country')"
                          :data-vv-as="$tc('models.country')"
                          required
                          ></v-select>
              </v-flex>

            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <img src="/openpay_color.png" width="100" alt="">

          <v-spacer></v-spacer>

          <v-btn color="default darken-1" flat="flat" @click="cardDialog = false">
            {{ $t('cancel') }}
          </v-btn>

          <v-btn color="primary darken-1" flat="flat" @click="createToken" :loading="loading">
            {{ $t('add') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import CreditCard from '@/client/credit-card'

import CountryList from '@/countries.json'

export default {
  name: 'AddFundsOpenpayNewCardComp',

  props: {
    settings: {
      type: Array,
      default: () => []
    }
  },

  data () {
    return {
      loading: false,
      cardDialog: false,
      countries: CountryList,
      address: {
        line1: '',
        line2: '',
        line3: '',
        city: '',
        state: '',
        postal_code: '',
        country_code: ''
      },
      card: {
        card_number: '',
        holder_name: '',
        expiration_year: '',
        expiration_month: '',
        cvv2: ''
      }
    }
  },

  components: {
  },

  computed: {
    merchantId () {
      const setting = this.settings.find(o => o.key === 'openpay_id')
      if (setting) { return setting.value }

      return ''
    },

    publicKey () {
      const setting = this.settings.find(o => o.key === 'openpay_public_key')
      if (setting) { return setting.value }

      return ''
    }
  },

  methods: {
    setOpenpay () {
      window.OpenPay.setSandboxMode(process.env.VUE_APP_OPENPAY_ENV === '1')
      window.OpenPay.setId(this.merchantId)
      window.OpenPay.setApiKey(this.publicKey)
    },

    async createToken () {
      const isValid = await this.$validator.validateAll()
      if (!isValid) { return }

      this.loading = true
      const self = this
      this.card.address = this.address
      window.OpenPay.token.create(this.card, function (response) {

        self.saveCard(response.data.id)

      }, function (response) {

        self.loading = false
        const err = new Error(response.data.description || response.message)
        self.handleErr(err)

      })
    },

    async saveCard (token) {
      if (!token) { return }

      const deviceSessionId = window.OpenPay.deviceData.setup()
      try {
        await CreditCard.create({
          token_id: token,
          device_session_id: deviceSessionId
        })
        this.cardDialog = false
        this.$emit('onCreate')
        this.reset()
      } catch (err) {
        this.handleErr(err)
      }
      this.loading = false
    },

    reset () {
      this.address = {
        line1: '',
        line2: '',
        line3: '',
        city: '',
        state: '',
        postal_code: '',
        country_code: ''
      }
      this.card = {
        card_number: '',
        holder_name: '',
        expiration_year: '',
        expiration_month: '',
        cvv2: ''
      }
    }
  },

  watch: {
    settings () {
      this.setOpenpay()
    }
  },

  async mounted () {
    this.setOpenpay()
  }
}
</script>
